// extracted by mini-css-extract-plugin
export var questionBox = "_9e-0";